import { DelegationPermission } from "./delegationPermissions";
import {
  VIRKSOMHEDSBLANKET_LEGACY_PATH,
  VIRKSOMHEDSBLANKET_PATH,
} from "./routes";

export interface AppNavItem {
  id: string;
  label: string;
  to: string;
  end?: boolean;
}

export interface AppDefinition {
  id: string;
  label: string;
  description?: string;
  basePath: string;
  permission?: DelegationPermission;
  /**
   * App'en dækker en forpligtelse, der tilhører en person — ikke et firma eller en revisor.
   *
   * Ejerskabet af data i sådan en app udledes af sessionen, så en firma-session ville lægge
   * firmaets id på en personlig forpligtelse. CLE-API'et afviser det nu; markøren her sørger
   * for, at brugeren slet ikke får tilbudt funktionen. Se `getVisibleApps`.
   */
  requiresPersonalIdentity?: boolean;
  match: (pathname: string) => boolean;
  navItems?: AppNavItem[];
}

// Matcher både den kanoniske sti og legacy-stien, så app-switcheren peger rigtigt i det
// øjeblik et gammelt bogmærke redirecter.
const isVirksomhedsblanketPath = (pathname: string) =>
  pathname.startsWith(VIRKSOMHEDSBLANKET_PATH) ||
  pathname.startsWith(VIRKSOMHEDSBLANKET_LEGACY_PATH);

/**
 * App-id'erne som konstanter. Kaldere slaar apps op paa id (se `isAppVisible`), og en
 * stavefejl i en løs streng ville skjule et kort uden at fejle nogen steder.
 */
export const APP_ID = {
  portal: "portal",
  efteruddannelse: "efteruddannelse",
  selskabsblanketten: "selskabsblanketten",
} as const;

export const APPS: AppDefinition[] = [
  {
    id: APP_ID.portal,
    label: "Indberetningsportalen",
    description: "Tilsyn, klientkonto m.m.",
    basePath: "/",
    match: (pathname) =>
      !isVirksomhedsblanketPath(pathname) &&
      !pathname.startsWith("/design") &&
      !pathname.startsWith("/efteruddannelse"),
    navItems: [],
  },
  {
    id: APP_ID.efteruddannelse,
    label: "Efteruddannelse",
    description: "Indberetning og dokumentation",
    basePath: "/efteruddannelse",
    permission: DelegationPermission.Efteruddannelse,
    requiresPersonalIdentity: true,
    match: (pathname) => pathname.startsWith("/efteruddannelse"),
    navItems: [],
  },
  {
    id: APP_ID.selskabsblanketten,
    label: "Virksomhedsblanketten",
    description: "Registrering af virksomhedsforhold",
    basePath: VIRKSOMHEDSBLANKET_PATH,
    permission: DelegationPermission.Selskabsblanketten,
    match: isVirksomhedsblanketPath,
    navItems: [],
  },
];
